import c from './TimeIndicator.module.scss';

const TimeIndicator = ({ style }) => {
  return <div className={c.timeIndicator} style={style} />;
};

export default TimeIndicator;
